module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"title":"Contestações pendentes","expires-at":"Expira em {days} dias"},"en-US":{"title":"Pending chargebacks","expires-at":"Expires in {days} days"}}')
  delete Component.options._Ctor
}
